const setting = {
  passwordTitle: "Şifre",
  changePasswordBtn: "Şifreyi Değiştir",
  changePasswordTips:
    "Şifrenizi unuttuysanız veya değiştirmek istiyorsanız, bunu buradan yapabilirsiniz; kayıtlı e-posta adresinize kimliğinizi doğrulamak için doğrulanması gereken bir doğrulama kodu göndereceğiz ve ardından hesap şifrenizi sıfırlayabilirsiniz.",
  feedbackTitle: "Geri bildirim",
  feedbackBtn: "Geri Bildirim Gönder",
  feedbackTips:
    "Size daha iyi hizmet verebilmemiz için, sorununuzu burada tarif edebilir ve geri bildirim için bize gönderebilirsiniz ve müşteri hizmetleri ekibimiz en kısa sürede sizinle iletişime geçecektir.",
  appearanceTitle: "Görünüm Ekranı",
  appearanceBtn: "Ekranı Değiştir",
  appearanceTips: "Sizin için iki görünüm modu seçiyoruz, böylece tercihinize göre karanlık ve aydınlık modlar arasında geçiş yapabilirsiniz.",
  changePassWordModalTitle: "Şifreyi Değiştir",
  changePassWordSameErrorTips: "Girdiğiniz yeni şifre eski şifrenizle aynıdır. Farklı bir şifre girin",
  changePasswordCurrentErrorTips: "Şifreniz yanlıştı. Lütfen tekrar deneyin.",
  currentPasswordLabel: "Geçerli şifre",
  newPasswordLabel: "Yeni şifre",
  retypePasswordLabel: "Yeni şifrenizi yeniden yazınız",
  changePasswordSuccessTips: "Şifreniz başarıyla değiştirildi.",
  changePasswordComfirmDiffErrorTips: "Lütfen her iki alana da aynı şifreyi girin.",
  forgotPassword: "Şifrenizi Mi Unuttunuz?",
  feedbackModalSubtitle: "Bizimle iletişime geçtiğiniz ve ürün hakkındaki görüşlerinizi bize bildirdiğiniz için teşekkür ederiz!",
  feedBackModalProductQuestion: "Ürünümüzle ne tür sorunları çözmek istiyorsunuz?",
  feedBackModalProductTypeSug: "Öneriler",
  feedBackModalProductTypeMem: "Üye hizmeti ile ilgili sorular",
  feedBackModalProductTypeFun: "Fonksiyon sorgulama",
  feedBackModalProductTypeReq: "Ürün Gereksinimleri",
  feedBackModalProductTypeBug: "Ürün hataları hakkında geri bildirim",
  feedBackModalProductTypeIss: "Performans Sorunları",
  feedBackModalProductTypeRL: "Kayıt ve giriş ile ilgili sorular",
  feedBackModalProductTypeRef: "Geri Ödeme Hizmeti",
  feedBackModalProductTypeOth: "Diğerleri",
  feedBackModalProductSelectQuestion: "Ürünümüzle ne tür sorunları çözmek istiyorsunuz?",
  feedBackModalProductContQuestion: "Ürünü kullanırken karşılaştığınız sorun nedir?",
  feedBackModalAddImageBtn: "Resim ekle",
  feedBackModalTips: "İpuçları:",
  feedBackModalTipsCont: "Küresel müşteri hizmetlerinin zaman farkı nedeniyle, iş gününden sonraki 48 saat içinde size cevap vereceğiz;",
  feedBackSuccessTips: "Gönderme başarılı",
  feedBackSuccessSubTips: "Sorununuzu en kısa sürede çözeceğiz",
  feedBackFailedTips: "Gönderilemedi",
  feedBackFailedSubTips: "Lütfen ağ bağlantınızın çalıştığından emin olun ve tekrar gönderin",
  appearanceLightMode: "Aydınlık modu",
  appearanceDarkMode: "Karanlık modu",
  promotionModalTitle: "Promosyon",
  promoItem: "Promosyon öğesi",
  promoCode: "Promosyon Kodu",
  discount: "İndirim",
  applyBtn: "Uygula",
  applyPromotionErrorTips: "Promosyon kodunuz geçersiz",
};

export default setting;
